<template>
  <div>
    <el-dialog
      :visible.sync="isShow"
      :width="dialogWidth"
      :class="[mcls]"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="appendToBody"
    >
      <div slot="title" class="dialog-top">
        <slot name="header">{{ title }}</slot>
      </div>
      <div>
        <slot />
      </div>
      <span slot="footer" class="dialog-footer" v-show="showDialogFooter">
        <slot name="bottom">
          <el-button
            v-if="showCancelBtn"
            :type="canceBtnType"
            size="mini"
            @click="close"
          >
            {{ cancelText }}
          </el-button>
          <el-button
            v-if="showOkBtn"
            :type="okBtnType"
            :loading="loading"
            size="mini"
            @click="sure"
            >{{ okText }}</el-button
          >
        </slot>
      </span>
      <!-- <div slot="bottom" class="box-recovery-bottom">
        <el-checkbox v-model="selectAll" class="mr_20" @change="clickChangeSelectAll">全选</el-checkbox>
        <div>
          <el-button type="primary" @click="saveSkuPic" size="mini">确 定</el-button>
          <el-button @click="cancel" size="mini">取 消</el-button>
        </div>
      </div>-->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    mcls: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标题'
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    showOkBtn: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: '确 定'
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    width: {
      type: Number,
      default: 500
    },
    isShow: {
      type: Boolean,
      default: true
    },
    showDialogFooter: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    okBtnType: {
      type: String,
      default: 'primary'
    },
    canceBtnType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefix: 'base-dialog'
      //  isShow: true
    }
  },
  computed: {
    dialogWidth() {
      return this.width + 'px'
    }
  },
  methods: {
    //  type 1-点击底部的取消按钮  0-右上角的关闭icon
    close() {
      this.$emit('on-close')
    },
    sure() {
      //  this.dialogVisible = false
      this.$emit('on-sure')
    },
    handleClose() {
      this.$emit('on-close')
      //  this.isShow = false;
    }
  }
}
</script>
<style lang="scss">
.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    background: #f5f7fa;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .dialog-top {
      font-size: 20px;
      color: #909399;
    }
  }
  .el-dialog__footer {
    background: #f5f7fa;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 10px 20px 10px;
  }
  .el-dialog__body {
    padding: 0px;
    color: #7c7d80;
    .dialog-body {
      font-size: 12px;
    }
    .el-form-item__label {
      font-size: 12px;
      font-weight: normal;
    }
  }
  // .box-recovery-bottom {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   background: #f5f7fa;
  //   padding: 0px 20px;
  //   padding-top: 10px;
  //   .label {
  //     color: $colorBlack1;
  //     font-weight: bold;
  //   }
  //   .color-primary {
  //     color: $colorPrimary;
  //     font-weight: bold;
  //   }
  // }
}
</style>
